import Spinner from "react-bootstrap/Spinner";

function Loading() {
  return (
    <Spinner animation="border" role="status" style={{ color: "white" }}>
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
}

export default Loading;
